/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

export interface IBusinessSignUpDropdownProps {
    id: string;
    value: string;
    dropdownOptions: string[];
    onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
}

export const BusinessSignUpDropdown2: React.FC<IBusinessSignUpDropdownProps> = props => {
    const { value, dropdownOptions, onChange, id } = props;
    return (
        <select value={value} id={id} className='msc-address-form__dropdown' onChange={onChange} name='business-sign-up-dropdown2'>
            {dropdownOptions &&
                dropdownOptions.map((element, index) => {
                    return (
                        <option value={element} key={index}>
                            {element}
                        </option>
                    );
                })}
        </select>
    );
};

export default BusinessSignUpDropdown2;
